<template lang="pug">
.appNavigationComponent
  .items(:class="MobileMenu")
    template(v-for="(item, index) in items")
      .item
        app-navigation-item(
          @click="closeMenu"
          :item="item",
          :key="index"
        )
</template>

<script>
import AppNavigationItem from './AppNavigationItem'
export default {
  components: {
    AppNavigationItem
  },
  inject: ['store'],
  props: {
    isMobileMenuOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['close-menu'],
  computed: {
    isHomepage () {
      return this.$route.name === 'Home'
    },
    items () {
      const items = []
      if (this.isHomepage) {
        items.push(
          {
            label: 'О сервисе',
            href: '#for'
          },
          {
            label: 'Что внутри?',
            href: '#about'
          },
          {
            label: 'Команда',
            href: '#command'
          }
        )
      } else {
        items.push(
          {
            label: 'Витрина',
            route: {
              name: 'Catalog'
            }
          }
          // {
          //   label: 'Тренажер ВПР',
          //   route: {
          //     name: 'Simulator'
          //   }
          // }
        )
        if (this.store.user.isAuthenticated) {
          items.push(
            {
              label: 'Я учусь',
              route: {
                name: 'BooksProgress'
              }
            },
            {
              label: 'Проверяю себя',
              route: {
                name: 'VprProgress'
              }
            }
          )
        }
      }
      return items
    },
    MobileMenu () {
      return this.isMobileMenuOpen ? 'mobile-menu-open' : 'mobile-menu-close'
    }
  },
  methods: {
    closeMenu () {
      this.$emit('close-menu')
    }
  }
}
</script>

<style lang="sass" scoped>
.appNavigationComponent
  @include font('t16-demibold')
  > .items
    display: flex
    @include gap(10*$u)

  @media (max-width: $XLWidth)
    .items
      @include gap(6*$u)

  @media (max-width: $padWidth)
    .items.mobile-menu-open
      @include gap($u)
      display: flex
      flex-direction: column

    .items.mobile-menu-close
      margin-top: 6*$u
      display: flex
      flex-wrap: wrap

  @media (max-width: $XSWidth)
    .items.mobile-menu-close
      align-items: flex-start
      flex-direction: column

  @media (max-width: $mobileWidth)
    .items.mobile-menu-open
      margin: 0
</style>
